import React from 'react'
import { Button } from "react-bootstrap";

export const Data = [
    { id: 1, exam: 'NEET Eaxms', class: 'XI', section: 'A', subjects: 'Bi.P.C', branches: 'All', conducted: '29-05-2019' },
    { id: 2, exam: 'NEET Eaxms', class: 'XI', section: 'A', subjects: 'Bi.P.C', branches: 'All', conducted: '29-05-2019' },
    { id: 3, exam: 'NEET Eaxms', class: 'XI', section: 'A', subjects: 'Bi.P.C', branches: 'All', conducted: '29-05-2019' },
    { id: 4, exam: 'NEET Eaxms', class: 'XI', section: 'A', subjects: 'Bi.P.C', branches: 'All', conducted: '29-05-2019' },
    { id: 5, exam: 'NEET Eaxms', class: 'XI', section: 'A', subjects: 'Bi.P.C', branches: 'All', conducted: '29-05-2019' },
    { id: 6, exam: 'NEET Eaxms', class: 'XI', section: 'A', subjects: 'Bi.P.C', branches: 'All', conducted: '29-05-2019' },
    { id: 7, exam: 'NEET Eaxms', class: 'XI', section: 'A', subjects: 'Bi.P.C', branches: 'All', conducted: '29-05-2019' },
    { id: 8, exam: 'NEET Eaxms', class: 'XI', section: 'A', subjects: 'Bi.P.C', branches: 'All', conducted: '29-05-2019' },
    { id: 9, exam: 'NEET Eaxms', class: 'XI', section: 'A', subjects: 'Bi.P.C', branches: 'All', conducted: '29-05-2019' },
    { id: 10,  exam: 'NEET Eaxms', class: 'XI', section: 'A', subjects: 'Bi.P.C', branches: 'All', conducted: '29-05-2019' },
    { id: 11,  exam: 'NEET Eaxms', class: 'XI', section: 'A', subjects: 'Bi.P.C', branches: 'All', conducted: '29-05-2019' },
    { id: 12,  exam: 'NEET Eaxms', class: 'XI', section: 'A', subjects: 'Bi.P.C', branches: 'All', conducted: '29-05-2019' },
    { id: 13,  exam: 'NEET Eaxms', class: 'XI', section: 'A', subjects: 'Bi.P.C', branches: 'All', conducted: '29-05-2019' },
    { id: 14,  exam: 'NEET Eaxms', class: 'XI', section: 'A', subjects: 'Bi.P.C', branches: 'All', conducted: '29-05-2019' },
    { id: 15,  exam: 'NEET Eaxms', class: 'XI', section: 'A', subjects: 'Bi.P.C', branches: 'All', conducted: '29-05-2019' },
    { id: 16,  exam: 'NEET Eaxms', class: 'XI', section: 'A', subjects: 'Bi.P.C', branches: 'All', conducted: '29-05-2019' },
    { id: 17,  exam: 'NEET Eaxms', class: 'XI', section: 'A', subjects: 'Bi.P.C', branches: 'All', conducted: '29-05-2019' },
    { id: 18,  exam: 'NEET Eaxms', class: 'XI', section: 'A', subjects: 'Bi.P.C', branches: 'All', conducted: '29-05-2019' },
    { id: 19,  exam: 'NEET Eaxms', class: 'XI', section: 'A', subjects: 'Bi.P.C', branches: 'All', conducted: '29-05-2019' },
    { id: 20,  exam: 'NEET Eaxms', class: 'XI', section: 'A', subjects: 'Bi.P.C', branches: 'All', conducted: '29-05-2019' },
    { id: 21,  exam: 'NEET Eaxms', class: 'XI', section: 'A', subjects: 'Bi.P.C', branches: 'All', conducted: '29-05-2019' },
    { id: 22,  exam: 'NEET Eaxms', class: 'XI', section: 'A', subjects: 'Bi.P.C', branches: 'All', conducted: '29-05-2019' },
    { id: 23,  exam: 'NEET Eaxms', class: 'XI', section: 'A', subjects: 'Bi.P.C', branches: 'All', conducted: '29-05-2019' },
    { id: 24,  exam: 'NEET Eaxms', class: 'XI', section: 'A', subjects: 'Bi.P.C', branches: 'All', conducted: '29-05-2019' },
    { id: 25,  exam: 'NEET Eaxms', class: 'XI', section: 'A', subjects: 'Bi.P.C', branches: 'All', conducted: '29-05-2019' },
    { id: 26,  exam: 'NEET Eaxms', class: 'XI', section: 'A', subjects: 'Bi.P.C', branches: 'All', conducted: '29-05-2019' },
    { id: 27,  exam: 'NEET Eaxms', class: 'XI', section: 'A', subjects: 'Bi.P.C', branches: 'All', conducted: '29-05-2019' },
    { id: 28,  exam: 'NEET Eaxms', class: 'XI', section: 'A', subjects: 'Bi.P.C', branches: 'All', conducted: '29-05-2019' },
    { id: 29,  exam: 'NEET Eaxms', class: 'XI', section: 'A', subjects: 'Bi.P.C', branches: 'All', conducted: '29-05-2019' },
    { id: 30,  exam: 'NEET Eaxms', class: 'XI', section: 'A', subjects: 'Bi.P.C', branches: 'All', conducted: '29-05-2019' },
    { id: 31,  exam: 'NEET Eaxms', class: 'XI', section: 'A', subjects: 'Bi.P.C', branches: 'All', conducted: '29-05-2019' },
    { id: 32,  exam: 'NEET Eaxms', class: 'XI', section: 'A', subjects: 'Bi.P.C', branches: 'All', conducted: '29-05-2019' },
    { id: 33,  exam: 'NEET Eaxms', class: 'XI', section: 'A', subjects: 'Bi.P.C', branches: 'All', conducted: '29-05-2019' },
    { id: 34,  exam: 'NEET Eaxms', class: 'XI', section: 'A', subjects: 'Bi.P.C', branches: 'All', conducted: '29-05-2019' },
    { id: 35,  exam: 'NEET Eaxms', class: 'XI', section: 'A', subjects: 'Bi.P.C', branches: 'All', conducted: '29-05-2019' },
    { id: 36,  exam: 'NEET Eaxms', class: 'XI', section: 'A', subjects: 'Bi.P.C', branches: 'All', conducted: '29-05-2019' },
    { id: 37,  exam: 'NEET Eaxms', class: 'XI', section: 'A', subjects: 'Bi.P.C', branches: 'All', conducted: '29-05-2019' },
    { id: 38,  exam: 'NEET Eaxms', class: 'XI', section: 'A', subjects: 'Bi.P.C', branches: 'All', conducted: '29-05-2019' },
    { id: 39,  exam: 'NEET Eaxms', class: 'XI', section: 'A', subjects: 'Bi.P.C', branches: 'All', conducted: '29-05-2019' },
    { id: 40,  exam: 'NEET Eaxms', class: 'XI', section: 'A', subjects: 'Bi.P.C', branches: 'All', conducted: '29-05-2019' },
 ];

export const Columns = [
    {
        dataField: "exam",
        text: "Exam Name",
        sort: true
    },
    {
        dataField: "class",
        text: "Class",
        sort: true
    },
    {
        dataField: "section",
        text: "Section",
        sort: true
    },
    {
        dataField: "subjects",
        text: "Subjects",
        sort: true
    },
    {
        dataField: "branches",
        text: "Branches",
        sort: true
    },
    {
        dataField: "conducted",
        text: "Conducted On",
        sort: true
    },
    {
        dataField: "actions",
        text: "Actions",
        sort: true,
        formatter: actionsFormatter,
        headerAttrs: { width: 50 },
        headerAlign: 'center',
        align: 'center',
        attrs: { width: 50, className: "EditRow" }
    }
];

export const defaultSorted = [
    {
        dataField: "title",
        order: "desc"
    }
];

function actionsFormatter(cell, row, rowIndex, formatExtraData) {
    return (
        <div className="actions-buttons d-flex justify-content-center align-items-top">
            <Button variant="link" className="text-theme"><i className="far fa-eye"/></Button>
            <Button variant="link" className="text-theme"><i className="far fa-edit"/></Button>
            <Button variant="link" className="text-danger"><i className="far fa-trash-alt"/></Button>
        </div>
    );
}


